import React, { ChangeEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Button,
  Tabs,
  Tab,
  Box,
  TextField,
  CardMedia,
  Input,
} from "@mui/material";
import EditText from "../../components/editText";
import AddFaq from "../../Modals/addFaq";
import AddIcon from "@mui/icons-material/Add";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import CloseIcon from "@mui/icons-material/Close";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import MapIcon from "@mui/icons-material/Map";
import "./manageCms.scss";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageCms = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  const [legal2, setLegal2] = useState<string>("");
  const [legal3, setLegal3] = useState<string>("");
  const [legal4, setLegal4] = useState<string>("");

  const [valueSubTabs, setValueSubTabs] = useState(0);
  const handleSubTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setValueSubTabs(newValue);
  };
  const [tcServiceProvider, setTcServiceProvider] = useState("");
  const [tcVendor, setTcVendor] = useState("");
  const [tcUser, setTcUser] = useState("");

  const [faqSubTab, setFaqSubTab] = useState(0);
  const handleFaqSubTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setFaqSubTab(newValue);
  };

  const [ppSubTab, setPpSubTab] = useState(0);
  const handlePpSubTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setPpSubTab(newValue);
  };
  const [ppServiceProvider, setPpServiceProvider] = useState("");
  const [ppVendor, setPpVendor] = useState("");
  const [ppUser, setPpUser] = useState("");


  const [mission, setMission] = useState("Empowering artisans, preserving heritage, and connecting global markets to local craftsmanship.");
  const [vision, setVision] = useState("To become the leading online marketplace for sustainable and luxury handmade goods from the Middle East.");
  const [overviewContent, setOverviewContent] = useState("<p>Bouteek is a premier platform connecting skilled artisans from the Middle East to discerning customers worldwide.</p><p>We are dedicated to preserving traditional crafts while fostering sustainable luxury goods.</p><ul><li>Showcase the unique heritage and artistry of the region</li><li>Provide a curated marketplace for luxury handmade goods</li><li>Support eco-conscious and ethical production practices.</li></ul>");

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const [error, setError] = useState(false);
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState(0);
  const [image, setImage] = useState<string>("");
  const [image2, setImage2] = useState<string>("");

  const [fileName, setFileName] = useState<string>("");
  const [color, setColor] = useState("#0CD0C6");
  return (
    <>
      <div className="main_title">
        <h1>Manage CMS</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          Manage CMS
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Contact Support" {...a11yProps(0)} />
              <Tab label="About Us" {...a11yProps(1)} />
              <Tab label="Legal" {...a11yProps(2)} />
              <Tab label="Terms & Conditions" {...a11yProps(3)} />
              <Tab label="Privacy Policy" {...a11yProps(4)} />
              <Tab label="FAQ's" {...a11yProps(5)} />

            </Tabs>
          </Box>
        </div>
      </div>
      <div className="table_flex">
        <div className="lt">

          <div className="cards">
            <CustomTabPanel value={valueTabs} index={0}>
              <form className="form">
                <div className="gap_p">
                  <div className="control_group w_50">
                    <label htmlFor="email">Email Address</label>
                    <TextField
                      id="email"
                      placeholder="Enter here"
                      fullWidth
                      hiddenLabel
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    {error && email == "" ? (
                      <h6 className="err_msg">Email is required</h6>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="control_group w_50">
                    <label htmlFor="phone">Phone Number</label>
                    <PhoneInput
                      country={"in"}
                      placeholder="Enter Phone Number"
                      enableSearch={false}
                      autoFormat={false}
                      inputStyle={{ width: "100%" }}
                    />
                  </div>
                </div>
                <div className="form_btn">
                  <Button
                    className="btn btn_primary"
                    onClick={() => {
                      setError(true);
                      if (email == "") return;
                      if (phone == "") return;
                      setError(false);
                    }}
                  >
                    Save
                  </Button>
                </div>
              </form>
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs} index={1}>
              <div className="section_card">
                <form className="form">
                  <div className="gap_p">
                    <div className="control_group w_50">
                      <label>Mission</label>
                      <div className="input_wrapper">
                        <TextField
                          multiline
                          rows={3}
                          value={mission}
                          onChange={(e) => setMission(e.target.value)}
                          fullWidth
                          hiddenLabel
                        />
                        <div className="char_limit">{mission.length}/90</div>
                      </div>
                    </div>
                    <div className="control_group w_50">
                      <label>Vision</label>
                      <div className="input_wrapper">
                        <TextField
                          multiline
                          rows={3}
                          value={vision}
                          onChange={(e) => setVision(e.target.value)}
                          fullWidth
                          hiddenLabel
                        />
                        <div className="char_limit">{vision.length}/400</div>
                      </div>
                    </div>

                    <div className="control_group w_100 mt_20">
                      <label>Overview</label>
                      <div className="rich_editor_container">
                        <div className="editor_main">
                          <EditText content={overviewContent} setContent={setOverviewContent} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form_btn">
                    <Button className="btn btn_primary">Save Changes</Button>
                  </div>
                </form>
              </div>
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs} index={2}>
              <EditText content={legal2} setContent={setLegal2} />
              <div className="form_btn">
                <Button className="btn btn_primary">Save</Button>
              </div>
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs} index={3}>
              <Box className="custom_tabs1" sx={{ width: "100%", mb: 3 }}>
                <Tabs
                  value={valueSubTabs}
                  onChange={handleSubTabChange}
                  aria-label="terms and conditions subtabs"
                  className="custom_tabs_links"
                >
                  <Tab label="Service Provider" {...a11yProps(0)} />
                  <Tab label="Vendor" {...a11yProps(1)} />
                  <Tab label="User" {...a11yProps(2)} />
                </Tabs>
              </Box>

              <CustomTabPanel value={valueSubTabs} index={0}>
                <EditText content={tcServiceProvider} setContent={setTcServiceProvider} />
                <div className="form_btn">
                  <Button className="btn btn_primary">Save</Button>
                </div>
              </CustomTabPanel>
              <CustomTabPanel value={valueSubTabs} index={1}>
                <EditText content={tcVendor} setContent={setTcVendor} />
                <div className="form_btn">
                  <Button className="btn btn_primary">Save</Button>
                </div>
              </CustomTabPanel>
              <CustomTabPanel value={valueSubTabs} index={2}>
                <EditText content={tcUser} setContent={setTcUser} />
                <div className="form_btn">
                  <Button className="btn btn_primary">Save</Button>
                </div>
              </CustomTabPanel>
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs} index={4}>
              <Box className="custom_tabs1" sx={{ width: "100%", mb: 3 }}>
                <Tabs
                  value={ppSubTab}
                  onChange={handlePpSubTabChange}
                  aria-label="privacy policy subtabs"
                  className="custom_tabs_links"
                >
                  <Tab label="Service Provider" {...a11yProps(0)} />
                  <Tab label="Vendor" {...a11yProps(1)} />
                  <Tab label="User" {...a11yProps(2)} />
                </Tabs>
              </Box>

              <CustomTabPanel value={ppSubTab} index={0}>
                <EditText content={ppServiceProvider} setContent={setPpServiceProvider} />
                <div className="form_btn">
                  <Button className="btn btn_primary">Save</Button>
                </div>
              </CustomTabPanel>
              <CustomTabPanel value={ppSubTab} index={1}>
                <EditText content={ppVendor} setContent={setPpVendor} />
                <div className="form_btn">
                  <Button className="btn btn_primary">Save</Button>
                </div>
              </CustomTabPanel>
              <CustomTabPanel value={ppSubTab} index={2}>
                <EditText content={ppUser} setContent={setPpUser} />
                <div className="form_btn">
                  <Button className="btn btn_primary">Save</Button>
                </div>
              </CustomTabPanel>
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs} index={5}>
              <Box className="custom_tabs1" sx={{ width: "100%", mb: 3 }}>
                <Tabs
                  value={faqSubTab}
                  onChange={handleFaqSubTabChange}
                  aria-label="faq subtabs"
                  className="custom_tabs_links"
                >
                  <Tab label="Service Provider" {...a11yProps(0)} />
                  <Tab label="Vendor" {...a11yProps(1)} />
                  <Tab label="User" {...a11yProps(2)} />
                </Tabs>
              </Box>

              {[0, 1, 2].map((subIndex) => (
                <CustomTabPanel key={subIndex} value={faqSubTab} index={subIndex}>
                  <div className="table_header">
                    <div className="left_s">
                      <SearchBar
                        searchTerm={searchTerm}
                        setDebouncedSearchTerm={setSearchTerm}
                        placeholder="Search..."
                      />
                    </div>
                    <div className="right_s">
                      <Button
                        className="btn btn_primary"
                        onClick={() => {
                          setIsEdit(false);
                          setOpenModal(true);
                        }}
                      >
                        <AddIcon /> Add FAQ
                      </Button>
                    </div>
                  </div>
                  <TableContainer className="table_container">
                    <Table>
                      <TableHead>
                        <TableRow hover>
                          <TableCell>Sr.no</TableCell>
                          <TableCell>Question</TableCell>
                          <TableCell>Answer</TableCell>
                          <TableCell>Created Date</TableCell>
                          <TableCell>Action</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow hover>
                          <TableCell>1</TableCell>
                          <TableCell>FAQ title here</TableCell>
                          <TableCell className="max_c2">
                            <p>
                              Lorem Ipsum is simply dummy text of the printing and
                              typesetting industry.
                            </p>
                          </TableCell>
                          <TableCell>12 Jan 2024</TableCell>
                          <TableCell>
                            <div className="table_actions v2">
                              <IconButton onClick={() => setOpenModal(true)}>
                                <img src="/static/images/edit2_icon.svg" alt="" />
                              </IconButton>
                              <IconButton>
                                <img src="/static/images/trash2_icon.svg" alt="" />
                              </IconButton>
                            </div>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CustomTabPanel>
              ))}
            </CustomTabPanel>

          </div>
        </div>
        <div className="rt">
          <div className="ai_panel d_flex gap_20 overflow-x-auto pb_10">
            <div
              className="ai_alert success flex-grow-1"
              style={{ minWidth: "300px" }}
            >
              <div className="d_flex align-center">
                <span className="icon">🚀</span>
                <p>
                  <b>High-Growth Alert:</b> 12 Vendors in 'Pro' hitting 90% AI
                  limits.
                  <Button
                    size="small"
                    variant="text"
                    sx={{ ml: 1, textTransform: "none" }}
                  >
                    Bulk Upgrade
                  </Button>
                </p>
              </div>
            </div>

            <div
              className="ai_alert danger flex-grow-1"
              style={{ minWidth: "300px" }}
            >
              <div className="d_flex align-center">
                <span className="icon">⚠️</span>
                <p>
                  <b>Churn Risk:</b> 5 Enterprise vendors inactive for 14+
                  days.
                  <Button
                    size="small"
                    variant="text"
                    sx={{ ml: 1, textTransform: "none" }}
                  >
                    View List
                  </Button>
                </p>
              </div>
            </div>

            <div
              className="ai_alert warning flex-grow-1"
              style={{ minWidth: "300px" }}
            >
              <div className="d_flex align-center">
                <span className="icon">💡</span>
                <p>
                  <b>Optimization:</b> "Scale+" segment has 40% higher GMV.
                  <Button
                    size="small"
                    variant="text"
                    sx={{ ml: 1, textTransform: "none" }}
                  >
                    Compare Plans
                  </Button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddFaq
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />
    </>
  );
};

export default ManageCms;
